export default "__VITE_ASSET__CO1g4e$O__"